// How a service job moves between statuses. Same rules as the backend (service.service.ts).
import type { JobStatus } from '../types/jobTypes';

export const TRANSITIONS: Record<JobStatus, JobStatus[]> = {
  pending: ['assigned', 'on_hold', 'cancelled'],
  assigned: ['in_progress', 'pending', 'on_hold', 'cancelled'],
  in_progress: ['completed', 'on_hold'],
  on_hold: ['assigned', 'in_progress', 'cancelled'],
  completed: ['in_progress'],
  invoiced: [],
  cancelled: ['pending'],
};

/** The only moves a worker may make on their own jobs. */
export const WORKER_ALLOWED: JobStatus[] = ['in_progress', 'completed', 'on_hold'];

/** Button / menu text for moving a job into a status: [label, icon]. */
export const ACTION_LABEL: Partial<Record<JobStatus, [label: string, icon: string]>> = {
  in_progress: ['Start work', 'wrench'],
  completed: ['Mark completed', 'checkCircle'],
  on_hold: ['Put on hold', 'clock'],
  assigned: ['Back to assigned', 'users'],
  pending: ['Move to not assigned', 'refresh'],
  cancelled: ['Cancel job', 'x'],
};

/** Statuses this person may move the job to next. */
export const allowedMoves = (status: JobStatus, isStaff: boolean): JobStatus[] => (TRANSITIONS[status] ?? []).filter((s) => isStaff || WORKER_ALLOWED.includes(s));

/** Jobs still waiting to be finished. */
export const OPEN_STATUSES: JobStatus[] = ['pending', 'assigned', 'in_progress', 'on_hold'];
